import React from 'react';

const BASE = 'https://www.pinpointfieldservices.com';

const services = [
  {
    heading: 'Mobile Notary Closings',
    href: `${BASE}/services/mobile-notary-closing/`,
    copy: 'We send closers we know to your borrower\'s location. Agents we\'ve worked with, not the nearest available name on a list.',
  },
  {
    heading: 'Remote Online Notarization',
    href: `${BASE}/services/remote-online-notarization/`,
    copy: 'Our RON closers have an established relationship with us and know how we work. Not a new vendor you\'ve never dealt with — the same standard you get from our in-person coverage. Available in 47+ states.',
  },
];

const HomepageServices = () => (
  <section style={{ backgroundColor: '#f8fafc', padding: '3rem 0' }}>
    <div className="container">
      <div className="text-center mb-5">
        <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1a202c' }}>What we cover</h2>
      </div>
      <div className="row g-4">
        {services.map(({ heading, href, copy }) => (
          <div key={heading} className="col-md-6">
            <a
              href={href}
              className="d-block h-100 text-decoration-none"
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '1.5rem',
                color: 'inherit',
                transition: 'box-shadow 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1a202c', marginBottom: '0.75rem' }}>
                {heading}
              </h3>
              <p style={{ fontSize: '0.95rem', color: '#4a5568', marginBottom: '1rem', lineHeight: '1.6' }}>
                {copy}
              </p>
              <span style={{ color: '#00bfff', fontWeight: '600', fontSize: '0.9rem' }}>
                Learn more →
              </span>
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HomepageServices;
